export enum ValueFilterType {
    Exclude = 'Exclude',
    Include = 'Include',
}
